import { IBlob } from '../../../services/employeeSkills.service';
import { IEmployee, EmployeeSkillsService, IEmployeeSkill, Masterdata } from "../../../services/index";
import * as moment from 'moment';

interface IResolve {
    employee: IEmployee;
    employeeSkills: IEmployeeSkill[];
    skills: Masterdata[];
}

class SkillsItemController {
    private file: IBlob;
    private uploadfile: any;
    private resolve: IResolve;
    private employee: IEmployee;
    private employeeSkill: IEmployeeSkill;
    private skills: Masterdata[];

    constructor(
        private EmployeeSkillsService: EmployeeSkillsService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService,
        private FileSaver: ng.FileSaver
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.employee = this.resolve.employee;
        this.skills = this.resolve.skills;
        if (this.$stateParams['employeeSkillId']) {
            this.employeeSkill = this.resolve.employeeSkills.find(s => s.id == this.$stateParams['employeeSkillId']);
            this.getFiles(this.$stateParams['employeeSkillId']);
        } else {
            this.employeeSkill = new IEmployeeSkill();
        }
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        if (this.employeeSkill.start) {
            var activeDate = moment(this.employeeSkill.start).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    startDateSelected() {
        this.employeeSkill.end = moment(this.employeeSkill.start).add(1, 'year').toDate();
    }

    public submitSkill() {
        this.employeeSkill.start = moment(this.employeeSkill.start).format("YYYY-MM-DD HH:mm");
        this.employeeSkill.end = moment(this.employeeSkill.end).format("YYYY-MM-DD HH:mm");

        if (this.employeeSkill.id === undefined) {

            if (this.employee) {
                this.employeeSkill.employeeId = this.employee.id;
            }
            this.EmployeeSkillsService.post(this.employeeSkill).then((data) => {
                if(this.uploadfile){
                    this.postFile(data.id).then(() => {
                        this.closeModal();
                    })
                } else {
                    this.closeModal();
                }
                
            });

        } else {
            this.EmployeeSkillsService.put(this.employeeSkill.id, this.employeeSkill).then((data) => {
                if(this.uploadfile){
                    this.postFile(data.id).then(() => {
                        this.closeModal();
                    })
                } else {
                    this.closeModal();
                }
            });
        }
    }

    private postFile = (id) => {
        return this.EmployeeSkillsService.postBlob(id, this.uploadfile);
    }

    public getFiles = (id) => {
        this.EmployeeSkillsService.getBlobs(id).then((files) => {
            this.file = files.value[files.value.length - 1];
        })
    }

    public downloadFile = (id) => {
        this.EmployeeSkillsService.getBlob(this.employeeSkill.id, id).then((blob) => {
            this.FileSaver.saveAs(blob, this.file.filenameWithExtention)
        })
    }   

    delete() {
        this.EmployeeSkillsService.delete(this.employeeSkill.id).then((data) => {
            this.closeModal();
        });
    }

    private closeModal() {
        this.$state.go('^', {tab: 4}, {reload: true});
    }
}

export const skillsItemComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: SkillsItemController,
    template: require('./skills.item.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/skills/skills.item.component.ts